import React from 'react';
import {Typography, Box, Stack} from '@mui/material';
import AlbumCreationStepper from "../../Components/AdminComponents/UploadImageComps/AlbumStepper";

const AdminSettings = () => {
    return (
        <Box>
            <Typography variant="h4" gutterBottom>
                Add Albums
            </Typography>
            <Stack spacing={2}>
                sadad
                <AlbumCreationStepper/>
            </Stack>
        </Box>
    );
};

export default AdminSettings;
